/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {Button, Icon} from "@scuf/common";


class ExpandablePanel extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            expanded: this.props.expanded,
        }
    }

    render() {
        return (
            <div className={this.getClassNames()}>
                <div className="header" onClick={() => this.setState({expanded: !this.state.expanded})}>
                    <div className="header-left">
                        <span className={'expandable-panel-title'}>{this.props.title}</span>
                        <div className="expand-icon">
                            <Icon name={this.state.expanded ? 'caret-up' : 'caret-down'} size="medium"/>
                        </div>
                    </div>
                    {this.props.showButton &&
                        <div>
                            <Button className="header-button" onClick={(e) => {
                                e.stopPropagation()
                                this.props.performAction()
                            }} content={"Add New Solution"}/>
                        </div>
                    }
                </div>
                <div className="content">
                    {this.props.children}
                </div>
            </div>
        )
    }

    getClassNames() {
        let result = 'ui expandable-panel'
        if (this.props.className) {
            result += ' ' + this.props.className
        }
        if (!this.state.expanded) {
            result += ' collapsed'
        }
        if (this.props.addonToClassName) {
            result += this.props.addonToClassName
        }
        return result;
    }
}


export default ExpandablePanel